import { Site } from '../../lib/common';
import { SensorGraph } from './sensor-graph';

import './sensor-graph';
import { DateTime } from 'luxon';

customElements
    .whenDefined('uscrn-sensor-graph')
    .then(async () => {
        const params: URLSearchParams = new window.URL(document.location.href)
            .searchParams;
        const controller = document.querySelector(
            'uscrn-sensor-graph'
        ) as SensorGraph;


        // TODO is this necessary? Why not just set the window title in the SensorGraph
        controller.addEventListener('siteChange', (ev: CustomEvent<Site>) => {
            document.title =
                'CRN Observation Graph for ' + ev.detail.displayName;
        });

        if (!params.has('siteId')) {
            throw new Error('URL param "siteId" not specified');
        } else {
            controller.siteId = parseInt(params.get('siteId'));
        }

        if (!params.has('config')) {
            throw new Error('URL param "config" not specified');
        } else {
            const config = params.get('config');
            try {
                controller.config = (await import(`./specs/${config}`)).default;
            } catch (e) {
                throw new Error(`Could not load config "${config}"`);
            }

        }

        let end = DateTime.utc();
        if(params.has('end')) {
            // Parse the URL 'end' parameter as an ISO timestamp - if it includes a fixed offset zone,
            // this will be used for the DateTime. Otherwise, zone defaults to utc
            const endUsr = DateTime.fromISO(params.get('end'), { setZone: true, zone: 'utc'});
            if(!endUsr.isValid) throw new Error('URL parameter "end" must be ISO 8601 format timestamp');

            // 'end' URL param was a valid ISO timestamp, so use it as the graph's end time
            end = endUsr;
        }

        // round the end to the start of its hour
        end = end.startOf('hour');

        const start = end.minus({ hours: 24 });
        controller.displayRange = { start, end };

        controller.zone = params.has('timezone')
            ? params.get('timezone').toLowerCase().trim() === 'utc'
                ? 'UTC'
                : 'LST'
            : 'UTC';
    })
    .catch((err) => {
        console.error(err);
        alert(err);
    });
